import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    OnInit,
    WritableSignal,
    computed,
    inject,
    signal,
} from '@angular/core'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { filter } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ROUTE_PREFIXES } from './core/constants/app.constants'
import { LayoutModule } from './layout/layout.module'
import { ZardToastComponent } from '@/styles/components/toast'

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, LayoutModule, ZardToastComponent, CdkScrollable],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    title = 'ei-navigator-ui'
    isSidebarExpanded: WritableSignal<boolean> = signal(false)
    private readonly router = inject(Router)
    private readonly destroyRef = inject(DestroyRef)
    private readonly isSchoolSiteRouteSignal = signal(false)

    protected readonly isSchoolSiteRoute = computed(() => this.isSchoolSiteRouteSignal())

    /** ngx-sonner (Sonner) — app-wide defaults */
    protected readonly toastOptions = {
        classes: {
            error: '!bg-red-50 !text-red-900 !border-red-200 !shadow-md',
            warning: '!bg-amber-50 !text-amber-950 !border-amber-200 !shadow-md',
            info: '!bg-sky-50 !text-sky-950 !border-sky-200 !shadow-md',
            success: '!bg-emerald-50 !text-emerald-950 !border-emerald-200 !shadow-md',
        },
    }

    toggleSidebar(): void {
        this.isSidebarExpanded.update((value) => !value)
    }

    ngOnInit(): void {
        this.setShellVisibility(this.router.url)
        this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((event) => this.setShellVisibility(event.urlAfterRedirects))
    }

    private setShellVisibility(url: string): void {
        this.isSchoolSiteRouteSignal.set(url.startsWith(ROUTE_PREFIXES.SCHOOL_SITE))
    }
}
